import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  liveMapMobileSurfaceAtom,
  LiveMapMobileSurfaceEnum,
  useIsMobile,
} from "@ryde/shared";

import { LiveMapGridStatusBreakdown } from "./live-map-icon-toggles";
import { LiveMapMobileGridStatusPanelStyled } from "./live-map.mobile-grid-status-panel.styled";
import { useLiveMapToolbarStats } from "./use-live-map-toolbar-stats";

export const LiveMapMobileGridStatusPanel: FC = () => {
  const { isMobile } = useIsMobile();
  const mobileSurface = useRecoilValue(liveMapMobileSurfaceAtom);
  const { gridStatusCounts } = useLiveMapToolbarStats();

  const isGridSurface = mobileSurface === LiveMapMobileSurfaceEnum.Grid;

  if (!isMobile || !isGridSurface) {
    return null;
  }

  return (
    <LiveMapMobileGridStatusPanelStyled>
      <LiveMapGridStatusBreakdown
        isMobileStrip
        statusCounts={gridStatusCounts}
      />
    </LiveMapMobileGridStatusPanelStyled>
  );
};
